// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__2JB5u","text":"SelectPayment_text__6ZoCU","title":"SelectPayment_title__1kpnG","btn":"SelectPayment_btn__Cj73q"};